import * as React from "react";
import { Provider } from "react-redux";
import { BrowserRouter as Router, useNavigate } from "react-router-dom";

import { persistedStore, store } from "./store/index";
import AuthProvider from "./oidcClient/authProvider";
import AppRoutes from "./routes/AppRoutes";
import { Toaster } from "./components/Common/Notification/AppNotifier";
import { PersistGate } from "redux-persist/integration/react";
import AxiosInterceptorsSetup from "src/axios-interceptor";

function AxiosInterceptorNavigate() {
    const navigate = useNavigate();
    AxiosInterceptorsSetup(navigate);
    return <></>;
}

const App: React.FC = () => (
    <Provider store={store}>
        <PersistGate persistor={persistedStore}>
            <AuthProvider store={store}>
                <Router>
                    <AxiosInterceptorNavigate />
                    <AppRoutes />
                </Router>
            </AuthProvider>
            <Toaster />
        </PersistGate>
    </Provider>
);

export default App;
